import React from 'react';
import PropTypes from 'prop-types';
import { format } from 'date-fns';
import Box from '@mui/material/Box';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import * as R from 'ramda';

import { formatNumberWithoutDecimals } from 'utils/helpers/format';
import DataDisplayItem from '../../components/DataDisplayItem';

const infoContainerStyle = {
  backgroundColor: 'surface.light',
  display: 'grid',
  gridTemplateAreas: {
    md: `"shipmentId"
        "origin"
        "bookingOrigin"
        "requestedDate"
        "product"
        "shipmentVolume"
        "totalDistributedVolume"
    `,
    xs: `"shipmentId requestedDate"
        "origin product"
        "bookingOrigin shipmentVolume"
        "totalDistributedVolume empty"`,
  },
  gridTemplateColumns: { md: '1fr', xs: '1fr 1fr' },
  rowGap: 2,
};

const ParentShipmentSummaryContent = ({ totalProposedVolume, shipmentData }) => {
  const shipmentDataProp = R.prop(R.__, shipmentData);

  return (
    <Box sx={infoContainerStyle}>
      <DataDisplayItem
        additionalStackStyling={{ gridArea: 'shipmentId' }}
        label="Shipment ID"
        value={shipmentDataProp('shipmentId')}
        valueVariant="subtitle2"
      />
      <DataDisplayItem
        additionalStackStyling={{ gridArea: 'origin' }}
        label="Origin"
        value={shipmentDataProp('originName')}
        valueVariant="subtitle2"
      />
      <DataDisplayItem
        additionalStackStyling={{ gridArea: 'bookingOrigin' }}
        label="BookingOrigin"
        value={shipmentDataProp('bookingOriginName')}
        valueVariant="subtitle2"
      />
      <DataDisplayItem
        additionalStackStyling={{ gridArea: 'requestedDate' }}
        label="Requested Date"
        value={format(new Date(shipmentDataProp('requestedDate')), 'P')}
        valueVariant="subtitle2"
      />
      <DataDisplayItem
        additionalStackStyling={{ gridArea: 'product' }}
        label="Product"
        value={shipmentDataProp('productName')}
        valueVariant="subtitle2"
      />
      <DataDisplayItem
        additionalStackStyling={{ gridArea: 'shipmentVolume' }}
        label="Shipment Volume"
        value={`${formatNumberWithoutDecimals(shipmentDataProp('volume'))} bbl`}
        valueVariant="subtitle2"
      />
      <Stack spacing={0.5} sx={{ gridArea: 'totalDistributedVolume' }}>
        <Stack alignItems="center" direction="row" spacing={1}>
          <Typography variant="caption">Total Distributed Volume</Typography>
          <Tooltip
            enterTouchDelay={10}
            title="Total Distributed Volume equals the sum of all associated distribution volumes."
          >
            <InfoRoundedIcon sx={{ color: 'graphic.main', fontSize: '14px' }} />
          </Tooltip>
        </Stack>
        <Typography variant="subtitle2">
          {`${formatNumberWithoutDecimals(totalProposedVolume)} bbl`}
        </Typography>
      </Stack>
    </Box>
  );
};

ParentShipmentSummaryContent.propTypes = {
  shipmentData: PropTypes.shape({}).isRequired,
  totalProposedVolume: PropTypes.number.isRequired,
};

export default ParentShipmentSummaryContent;
